import { KText } from 'ui-library/components';

export const HighlightedText = ({ text, highlight }) => {
  const words = text.split(
    new RegExp(`(${highlight.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')})`, 'gi')
  );
  return (
    <KText as="span" color="secondary-900" size="sm-semi-bold">
      {words.map((word, i) => (
        <KText
          as="span"
          key={i}
          size={`${
            word.toLowerCase() === highlight.toLowerCase()
              ? 'sm-semi-bold'
              : 'sm-regular'
          }
          `}
          color="secondary-900"
        >
          {word}
        </KText>
      ))}
    </KText>
  );
};
